import gql from 'graphql-tag'
import client from '@stores/apollo'
import handleFetchResult from '@utils/handleFetchResult'

interface CSVVariables {
  orderBy: string
  where: any
}

interface IPayload {
  createBookingExport: { export: { url: string } }
}

const mutateHandler = handleFetchResult<IPayload, string>({
  handler: (data) => data.createBookingExport.export.url,
  name: 'CSV',
})

export default function csv({ orderBy, where }: CSVVariables): Promise<string> {
  return client.gql
    .mutate({ mutation, variables: { input: { orderBy, where } } })
    .then(mutateHandler)
}

const mutation = gql`
  mutation CreateBookingExport($input: CreateBookingExportInput!) {
    createBookingExport(input: $input) {
      export {
        url
        name
      }
    }
  }
`
